import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";

const SessionActions = ({
  slot,
  offerDetail,
  slotUpdateStatusLoading,
  reviewAndRating,
  handleCreateOfferCardModal,
  RETAKE_TYPE,
}) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [canRetake, setCanRetake] = useState(false);

  useEffect(() => {
    const calculateTimeRemaining = () => {
      // Current time in local timezone
      const now = DateTime.local();

      // Parse the slot.date (UTC format) and slot.endTime
      const [hours, minutes, seconds] = slot.endTime.split(":").map(Number);

      // Create a DateTime object from the UTC date and time
      const slotEndDateTime = DateTime.fromISO(slot.date, { zone: "utc" })
        .set({ hour: hours, minute: minutes, second: seconds || 0 })
        .toLocal(); // Convert to local timezone

      // Create retake deadline (24 hours after session end)
      const retakeDeadline = slotEndDateTime.plus({ hours: 24 });

      if (now >= slotEndDateTime && now <= retakeDeadline) {
        setCanRetake(true);

        // Calculate time difference
        const diff = retakeDeadline
          .diff(now, ["hours", "minutes", "seconds"])
          .toObject();

        // Format the time left
        const hoursLeft = Math.floor(diff.hours || 0);
        const minutesLeft = Math.floor(diff.minutes || 0);
        const secondsLeft = Math.floor(diff.seconds || 0);

        setTimeLeft(`${hoursLeft}h ${minutesLeft}m ${secondsLeft}s`);
      } else {
        setCanRetake(false);

        // If the session hasn't even ended yet
        if (now < slotEndDateTime) {
          setTimeLeft("Session not yet ended");
        } else {
          setTimeLeft("Retake window expired");
        }
      }
    };

    // Initial calculation
    calculateTimeRemaining();

    // Update every second
    const interval = setInterval(calculateTimeRemaining, 1000);

    return () => clearInterval(interval);
  }, [slot.date, slot.endTime]);

  return (
    <>
      <div className="form-check">
        <input
          disabled={slotUpdateStatusLoading}
          onChange={() => reviewAndRating(offerDetail, slot)}
          name={"teachingMode"}
          className="form-check-input"
          type="checkbox"
        />
        <label
          className="form-check-label fs_12 text-danger"
          htmlFor="cityCheckbox1"
        >
          Mark as Completed
        </label>
      </div>

      {timeLeft && canRetake && (
        <div className="mt-2 mb-2">
          <small className="text-warning">
            Retake available: {timeLeft} remaining
          </small>
        </div>
      )}

      {canRetake && (
        <div className="form-check">
          <label
            className="form-check-label fs_12 text-danger cursor_pointer"
            htmlFor="cityCheckbox1"
            onClick={() => handleCreateOfferCardModal(RETAKE_TYPE, slot)}
          >
            Request to Retake
          </label>
        </div>
      )}
    </>
  );
};

export default SessionActions;
